<template>
    <icon-base v-bind="$props">
        <path d="M18 6l-12 12"></path>
        <path d="M6 6l12 12"></path>
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
